import { useState } from "react";
import { SlidersHorizontal, X } from "lucide-react";
import { DURATA_BUCKETS, KM_BUCKETS, RATA_BUCKETS } from "../lib/nltFilters";

const Chip = ({ active, onClick, label, testid }) => (
    <button
        type="button"
        onClick={onClick}
        data-testid={testid}
        className={`px-3 py-1.5 rounded-full text-xs font-bold transition-all border-2 ${
            active
                ? "bg-[#0C4650] text-white border-[#0C4650]"
                : "bg-white text-[#0C4650] border-gray-200 hover:border-[#0C4650]"
        }`}
    >
        {label}
    </button>
);

export default function NltFilters({ filters, setFilters, totalMatches }) {
    const [expanded, setExpanded] = useState(false);

    const toggle = (group, value) => {
        setFilters((prev) => {
            const list = prev[group] || [];
            const next = list.includes(value)
                ? list.filter((v) => v !== value)
                : [...list, value];
            return { ...prev, [group]: next };
        });
    };

    const clearAll = () => setFilters({ durata: [], km: [], rata: [] });

    const activeCount =
        (filters.durata?.length || 0) +
        (filters.km?.length || 0) +
        (filters.rata?.length || 0);

    return (
        <div className="card p-4 mb-5" data-testid="nlt-filters-bar">
            <div className="flex items-center justify-between flex-wrap gap-2">
                <button
                    type="button"
                    onClick={() => setExpanded((v) => !v)}
                    className="inline-flex items-center gap-2 text-sm font-bold text-[#0C4650]"
                    data-testid="nlt-filters-toggle"
                >
                    <SlidersHorizontal className="w-4 h-4" />
                    Filtri rapidi
                    {activeCount > 0 && (
                        <span className="ml-1 bg-[#C7FF2C] text-[#0C4650] text-[10px] font-black px-1.5 py-0.5 rounded-full">
                            {activeCount}
                        </span>
                    )}
                </button>
                <div className="flex items-center gap-3">
                    <span className="text-xs text-gray-500">
                        {totalMatches} risultat{totalMatches === 1 ? "o" : "i"}
                    </span>
                    {activeCount > 0 && (
                        <button
                            type="button"
                            onClick={clearAll}
                            className="text-xs font-bold text-[#0C4650] inline-flex items-center gap-1 hover:underline"
                            data-testid="nlt-filters-clear"
                        >
                            <X className="w-3 h-3" /> Reset
                        </button>
                    )}
                </div>
            </div>

            {expanded && (
                <div className="mt-4 space-y-4 border-t border-gray-100 pt-4"
                     data-testid="nlt-filters-panel">
                    <div>
                        <div className="text-[10px] tracking-widest font-bold text-[#898A8D] mb-2">
                            DURATA
                        </div>
                        <div className="flex flex-wrap gap-2">
                            {DURATA_BUCKETS.map((d) => (
                                <Chip
                                    key={d}
                                    active={(filters.durata || []).includes(d)}
                                    onClick={() => toggle("durata", d)}
                                    label={`${d} mesi`}
                                    testid={`nlt-filter-durata-${d}`}
                                />
                            ))}
                        </div>
                    </div>

                    <div>
                        <div className="text-[10px] tracking-widest font-bold text-[#898A8D] mb-2">
                            KM ANNUI
                        </div>
                        <div className="flex flex-wrap gap-2">
                            {KM_BUCKETS.map((b) => (
                                <Chip
                                    key={b.key}
                                    active={(filters.km || []).includes(b.key)}
                                    onClick={() => toggle("km", b.key)}
                                    label={b.label}
                                    testid={`nlt-filter-km-${b.key}`}
                                />
                            ))}
                        </div>
                    </div>

                    <div>
                        <div className="text-[10px] tracking-widest font-bold text-[#898A8D] mb-2">
                            FASCIA RATA MENSILE
                        </div>
                        <div className="flex flex-wrap gap-2">
                            {RATA_BUCKETS.map((b) => (
                                <Chip
                                    key={b.key}
                                    active={(filters.rata || []).includes(b.key)}
                                    onClick={() => toggle("rata", b.key)}
                                    label={b.label}
                                    testid={`nlt-filter-rata-${b.key}`}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
